var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 23.1v-.2c4-1.3 8-4.8 8-11.1C40.8 5.3 37.6.2 26.4.2H4.5v5.3l2.8.8c.9.3 1.6 1.1 1.6 2.1v31.4c0 .9-.6 1.8-1.5 2.1l-2.8.9v5.1h21.3c10.3 0 17.7-3.3 17.7-13-.1-6.7-3.3-11-10.8-11.8zM19.7 6.7h5.4c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5h-5.4v-13zm7.5 33.5h-7.6v-13h7.6c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNMzIuOCAyMy4xdi0uMmM0LTEuMyA4LTQuOCA4LTExLjFDNDAuOCA1LjMgMzcuNi4yIDI2LjQuMkg0LjV2NS4zbDIuOC44Yy45LjMgMS42IDEuMSAxLjYgMi4xdjMxLjRjMCAuOS0uNiAxLjgtMS41IDIuMWwtMi44Ljl2NS4xaDIxLjNjMTAuMyAwIDE3LjctMy4zIDE3LjctMTMtLjEtNi43LTMuMy0xMS0xMC44LTExLjh6TTE5LjcgNi43aDUuNGMzLjYgMCA2LjUgMi45IDYuNSA2LjVzLTIuOSA2LjUtNi41IDYuNWgtNS40di0xM3ptNy41IDMzLjVoLTcuNnYtMTNoNy42YzMuNiAwIDYuNSAyLjkgNi41IDYuNXMtMi45IDYuNS02LjUgNi41eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgBold as ReactComponent };